<template>
    <div class="grid-x  grid-margin-y grid-margin-x small-up-1 medium-up-3">
        <div class="cell" v-for="(worker, index) in workers" :key="index">
            <v-card>
                <v-card-title>
                    <span class="headline">
                        {{ worker.full_name }}
                    </span>
                </v-card-title>
                <v-card-text>
                    <div class="grid-x grid-margin-x">
                        <div class="cell small-6">
                            Dept #{{ worker.id }}
                        </div>
                        <div class="cell small-6">
                            {{ worker.email }}
                        </div>
                      <div class="cell small-6 uppercase">
                        {{ worker.account_type }}
                      </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat color="warning" @click="editCustomer(worker)" :disabled="worker.account_type === 'retired'">
                        Edit
                    </v-btn>
                  <v-btn v-if="!$readOnly" flat color="error" @click="retireWorker(worker)" :disabled="worker.account_type === 'retired'">
                    Retire
                  </v-btn>
                </v-card-actions>
            </v-card>
        </div>
    </div>
</template>

<script>
export default {
    props: ['workers'],

    methods: {
        editCustomer(worker) {
            this.$emit('load-worker', worker.id);
        },

      retireWorker(worker) {
          const confirmation = confirm('Are you sure you want to retire this worker? They won\'t be able to login to the application.')

        if(!confirmation) return false;

        this.$emit('retire-worker', worker.id);
      }
    }
}
</script>

<style>

</style>


